
const queryDOM = {
    body: document.querySelector('body'),
    button: document.querySelectorAll('#credibility .button--block'),
    modal: document.querySelector('#credibility .modal'),
    image: document.querySelector('#credibility .modal .image'),
    content: document.querySelector('#credibility .modal .content'),
    close: document.querySelector('#credibility .modal .close')
}

const content = {
    'block--1': "<h2>1600+ scientific publications in our team</h2><p>At Alba Health, we’re dedicated to supporting your child's health by collaborating with top pediatricians, gastroenterologists, nutritionists, and researchers who make up our esteemed scientific advisory board. Together, they have over 1,600 scientific publications combined. Our Scientific Co-founder, Distinguished Professor Emeritus Willem M. de Vos, is a world-renowned expert in the microbiome field with over 800 publications. He co-leads the HELMi Cohort, one of the largest and most comprehensive studies on child gut health. You can feel confident knowing that your child's well-being is being guided by top experts in the field.</p><p>Learn more about or scientific advisory board <a href='https://www.albahealth.co/for-doctors' class='link_normal' target='_blank' rel='noopener noreferrer'>here</a>.</p>",
    'block--2': "<h2>We collaborate with the world’s largest study</h2><p>We have a collaboration with the University of Helsinki’s Health and Early Life Microbiota (HELMi) cohort, a world-leading research initiative focused on child health. This groundbreaking study explores the connection between gut health, lifestyle, and overall health outcomes, analyzing over 10,000 microbiome samples and 50,000 lifestyle data points. This collaboration allows us to uncover essential and unique insights that help you on your journey to support your child’s wellbeing.</p><p>Learn more about HELMi <a href='https://helmitutkimus.com/helmi-in-english/' class='link_normal' target='_blank' rel='noopener noreferrer'>here</a>.</p>",
    'block--3': "<h2>We pioneer the largest study on child health in Sweden</h2><p>Our aim is to provide you with new valuable insights and actionable recommendations. That’s why we launched our own study, the PREVENT study – the largest company-led study of its kind, in partnership with Uppsala University, Universiteit Antwerpen, and COPSAC. With over 300 families participating, the aim with the study is to connect the gut microbiome to top concerns for parents like crying, sleep, digestion and eventually - health symptoms. By doing this, we want to provide genuine and distinctive benefits to you as a parent, assisting you in promoting the long-term well-being and healthful development of their baby.</p><p>Read more about our study <a href='https://www.albahealth.co/prevent-study' class='link_normal' target='_blank' rel='noopener noreferrer'>here</a>.</p>"
}

let scrollY;

const toggleModal = (el) => {
    
    const block = el.dataset.id;
    let html = content[block];
    let img = el.parentElement.parentElement.parentElement.children[0].innerHTML;
    if (block !== 'close') {
        scrollY = window.scrollY;
        queryDOM.image.innerHTML = img;
    }
    html ? queryDOM.content.innerHTML = html : queryDOM.content.innerHTML = '';
    queryDOM.modal.classList.toggle('hide');
    queryDOM.body.classList.toggle('no-scroll');
    if (block == 'close') {
        window.scrollTo({
            top: scrollY,
            left: 0,
            behavior: "instant",
        });
        queryDOM.image.innerHTML = '';
    }
}

queryDOM.button.forEach((entry) => {
    entry.setAttribute('onclick', 'event.preventDefault()');
    entry.addEventListener('click', (el) => {
        toggleModal(el.target);
    });
});